/*eslint-disable*/
import { createStructuredSelector } from 'reselect';

import {
  servicesFiltersSelector,
  servicesPresentationalFiltersSelector,
  servicesSearchValuesSelector,
  showServicesSelector,
} from '@selectors/filterServicesSelector';

export const structuredSelector = createStructuredSelector({
  services: servicesFiltersSelector,
  search: servicesSearchValuesSelector,
  options: servicesPresentationalFiltersSelector,
  showServices: showServicesSelector,
});

export type StructuredSelectorProps = {
  services: [string];
  search: string;
  options: [any];
};
